import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthEntry = () => {
    return <Outlet />
};

export default AuthEntry;